import { createAction } from 'redux-actions';

export const SET_CURRENT_CHANNEL_ID = 'SET_CURRENT_CHANNEL_ID';
export const setCurrentChannelId = createAction<string>(SET_CURRENT_CHANNEL_ID);
